import { Button, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { InsightDetail } from '@fullstory/redux';
import React, { useRef, useState } from 'react';
import { InsightsActionList } from '../InsightsActionList';
import css from './index.module.scss';

export const InsightsActionMenu: React.FC<{ insights: InsightDetail[] }> = ({ insights }) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const ariaLabel = intl.formatMessage(
    {
      defaultMessage:
        '{numInsights, number} {numInsights, plural, one {insight} other {insights}} available',
      id: 'zBNMSb',
    },
    { numInsights: insights.length },
  );

  return (
    <>
      <Button
        aria-label={ariaLabel}
        variant="minimal"
        innerRef={buttonRef}
        fullWidth
        onClick={e => {
          setOpen(prev => !prev);
          e.stopPropagation();
        }}
        justifyContent="center"
      >
        <Text appearance="bodySmall" className={css.underline}>
          {insights.length}
        </Text>
      </Button>
      <InsightsActionList
        open={open}
        insights={insights}
        setOpen={setOpen}
        buttonRef={buttonRef}
        placement="bottom-start"
      />
    </>
  );
};
